import { render } from "./SanityBlocks.vue?vue&type=template&id=7c3af3a4"
import script from "./SanityBlocks.vue?vue&type=script&lang=js"
export * from "./SanityBlocks.vue?vue&type=script&lang=js"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__